export enum CronFrequency {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY'
}

export enum CronConfiguratorControlNames {
  FREQUENCY = 'frequency',
  TIME = 'time',
  WEEK_DAY = 'weekDay',
  MONTH_DAY = 'monthDay'
}

export const CRON_FREQUENCY_OPTIONS: CronFrequency[] = [CronFrequency.DAILY, CronFrequency.WEEKLY, CronFrequency.MONTHLY];

export const CRON_MONTH_DAYS: number[] = Array.from({ length: 31 }, (_, index) => index + 1);

/** Day-of-week options. `value` is the cron day number (0 = Sunday); `label` is an i18n key suffix. */
export const CRON_WEEK_DAYS: { value: number; label: string }[] = [
  { value: 1, label: 'MONDAY' },
  { value: 2, label: 'TUESDAY' },
  { value: 3, label: 'WEDNESDAY' },
  { value: 4, label: 'THURSDAY' },
  { value: 5, label: 'FRIDAY' },
  { value: 6, label: 'SATURDAY' },
  { value: 0, label: 'SUNDAY' }
];

/** Normalized schedule used to build/parse a cron string. `time` is `HH:mm` in UTC. */
export interface CronSchedule {
  frequency: CronFrequency;
  time: string;
  weekDay: number;
  monthDay: number;
}
